import { SizeTypeTokens, } from '@voltmoney/schema';
export const sizeTypeTokensMap = {
    [SizeTypeTokens.NONE]: 0,
    [SizeTypeTokens.Size1]: 1,
    [SizeTypeTokens.XS]: 2,
    [SizeTypeTokens.SM]: 4,
    [SizeTypeTokens.Size6]: 6,
    [SizeTypeTokens.MD]: 8,
    [SizeTypeTokens.Size10]: 10,
    [SizeTypeTokens.LG]: 12,
    [SizeTypeTokens.XL]: 16,
    [SizeTypeTokens.SIZE14]: 14,
    [SizeTypeTokens.SIZE18]: 18,
    [SizeTypeTokens.XXL]: 20,
    [SizeTypeTokens.XXXL]: 24,
    [SizeTypeTokens.Size30]: 30,
    [SizeTypeTokens.Size32]: 32,
    [SizeTypeTokens.XXXXL]: 40,
    [SizeTypeTokens.SIZE42]: 42,
    [SizeTypeTokens.XXXXXL]: 48,
    [SizeTypeTokens.SIZE_46]: 46,
    [SizeTypeTokens.XXXXXXL]: 56,
    [SizeTypeTokens.SIZE72]: 62,
    [SizeTypeTokens.Size80]: 80,
    [SizeTypeTokens.SIZE_MINUS_16]: -16,
    [SizeTypeTokens.SIZE_26]: 26,
};
